var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "hr_block" }, [
    _c(
      "div",
      { staticClass: "row", class: { "flex-wrap-reverse": _vm.is_modal } },
      [
        _c("div", { class: _vm.col_left }, [
          _c("div", { staticClass: "hr_edit_inside" }, [
            _c("div", { staticClass: "form-group mt-2" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "advanced_name" } },
                [_vm._v("\n                    ПІБ *\n                ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "input-group flex-nowrap" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.user_data.name,
                      expression: "user_data.name",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { id: "advanced_name", type: "text" },
                  domProps: { value: _vm.user_data.name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.user_data, "name", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group mt-2" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "advanced_name" } },
                [
                  _vm._v(
                    "\n                    Дата народження\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "input-group flex-nowrap" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.user_data.birthday,
                      expression: "user_data.birthday",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { id: "advanced_name", type: "text" },
                  domProps: { value: _vm.user_data.birthday },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.user_data, "birthday", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group mt-2" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "advanced_name" } },
                [
                  _vm._v(
                    "\n                    Користувач транслiт *\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "input-group flex-nowrap" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.user_data.username,
                      expression: "user_data.username",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { id: "advanced_name", type: "text" },
                  domProps: { value: _vm.user_data.username },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.user_data, "username", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group mt-2" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "advanced_name" } },
                [
                  _vm._v("\n                    Пароль\n                    "),
                  _vm.is_modal
                    ? _c("span", { staticClass: "small" }, [
                        _vm._v("Залиште пустим, якщо без змін"),
                      ])
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "input-group flex-nowrap" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.user_data.password,
                      expression: "user_data.password",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { id: "advanced_name", type: "text" },
                  domProps: { value: _vm.user_data.password },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.user_data, "password", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group mt-2" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "advanced_name" } },
                [_vm._v("\n                    Вiддiл*\n                ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "input-group flex-nowrap" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.user_data.department,
                      expression: "user_data.department",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { id: "advanced_name", type: "text" },
                  domProps: { value: _vm.user_data.department },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.user_data, "department", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group mt-2" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "advanced_name" } },
                [_vm._v("\n                    Посада*\n                ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "input-group flex-nowrap" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.user_data.dolznost,
                      expression: "user_data.dolznost",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { id: "advanced_name", type: "text" },
                  domProps: { value: _vm.user_data.dolznost },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.user_data, "dolznost", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "template" },
              [
                _c("users_org_select", {
                  attrs: { active_name: _vm.user_data.company },
                  on: { on_item_set: _vm.set_company },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "template" },
              [
                _c("cluster_select", {
                  attrs: { active_id: parseInt(_vm.user_data.serv_id) },
                  on: { on_item_set: _vm.set_cluster_id },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group mt-2" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "advanced_name" } },
                [_vm._v("\n                    Тел. робочий\n                ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "input-group flex-nowrap" }, [
                _vm._m(6),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.user_data.mobile,
                      expression: "user_data.mobile",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "advanced_name",
                    maxlength: "10",
                    inputmode: "numeric",
                    pattern: "[0-9]*",
                    type: "text",
                  },
                  domProps: { value: _vm.user_data.mobile },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user_data, "mobile", $event.target.value)
                      },
                      function ($event) {
                        _vm.user_data.mobile = _vm.user_data.mobile
                          .replace(/\D/g, "")
                          .slice(0, 10)
                      },
                    ],
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group mt-2" }, [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "advanced_name" } },
                [
                  _vm._v(
                    "\n                    Тел. особистий\n                "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "input-group flex-nowrap" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.user_data.home,
                      expression: "user_data.home",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "advanced_name",
                    maxlength: "10",
                    inputmode: "numeric",
                    pattern: "[0-9]*",
                    type: "text",
                  },
                  domProps: { value: _vm.user_data.home },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user_data, "home", $event.target.value)
                      },
                      function ($event) {
                        _vm.user_data.home = _vm.user_data.home
                          .replace(/\D/g, "")
                          .slice(0, 10)
                      },
                    ],
                  },
                }),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.col_right }, [
          _vm.doc.user_id > 0
            ? _c(
                "div",
                [
                  _c("h2", [_vm._v("Користувач")]),
                  _vm._v(" "),
                  _c("user-block", { attrs: { user_id: _vm.doc.user_id } }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "buttons pt-3" }, [
      _c("div", { staticClass: "next_step" }, [
        _vm.doc.confirmed == 0
          ? _c(
              "button",
              {
                staticClass:
                  "btn btn-lg btn-outline-success save_user waves-effect waves-themed",
                attrs: { disabled: !_vm.can_save },
                on: { click: _vm.save_info },
              },
              [
                _vm._v("\n                Зберегти\n                "),
                _c("div", { staticClass: "ripple-wrapper" }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.can_confirm
          ? _c(
              "button",
              {
                staticClass:
                  "btn btn-lg btn-outline-success save_user waves-effect waves-themed ml-5",
                on: { click: _vm.confirm },
              },
              [
                _vm._v("\n                Затвердити\n                "),
                _c("div", { staticClass: "ripple-wrapper" }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "btn btn-lg btn-outline-primary save_user waves-effect waves-themed",
            class: { "ml-5": _vm.doc.confirmed == 0 },
            on: { click: _vm.go_main },
          },
          [
            _vm._v("Закрити\n                "),
            _c("div", { staticClass: "ripple-wrapper" }),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }